/**
 * Year wording for the chat upload cards (PLT-5088).
 *
 * Chat-saved operational data and sustainability indicators are always written for the current year,
 * the same year the manual form writes, because the Operational data tab and the DMA work on one year
 * at a time. Reports usually describe an earlier year, so the cards name both: the report's year the
 * figures came from and the year they are saved for.
 */

/**
 * "From the 2025 report · saved for 2026", or "Saved for 2026" when no report year is known or it
 * already is the current year. Several distinct report years read "From the 2024 and 2025 reports".
 */
export function savedForYearLabel(reportYears: Array<number | undefined>): string {
  const currentYear = new Date().getFullYear();
  const years = [...new Set(reportYears.filter((y): y is number => y !== undefined && y !== currentYear))].sort(
    (a, b) => a - b,
  );
  if (years.length === 0) return `Saved for ${currentYear}`;
  const reports =
    years.length === 1
      ? `the ${years[0]} report`
      : `the ${years.slice(0, -1).join(', ')} and ${years[years.length - 1]} reports`;
  return `From ${reports} · saved for ${currentYear}`;
}
